export default __webpack_public_path__ + "static/accordianTabsBg-3fa6627624b53372149e8f10db00dd98.png";